module.exports = __webpack_public_path__ + "static/media/BMODE_50_40.7de6f426.jpg";